/** @file Saves UI settings: merges a patch into the store's values, PUTs the whole object, stores the answer. */
import type { ApiClient } from '../../api/createApiClient';
import { settingsStore } from '../../stores/settingsStore';
import type { SettingsSlice } from '../../stores/types';
import { toSettingsSlice } from './toSettingsSlice';

/** Every save waits for the one before it, so its merge reads the store after that save's answer landed. */
let queue: Promise<unknown> = Promise.resolve();

/** Sends all three fields so the Worker never has to merge; saves run one at a time and the store changes only after a PUT succeeds. */
export function updateUiSettings(client: Pick<ApiClient, 'putUiSettings'>, patch: Partial<SettingsSlice>): Promise<void> {
  const run = queue.then(async () => {
    const next = { ...settingsStore.getState(), ...patch };
    const saved = await client.putUiSettings({ lang: next.lang, layout: next.layout, shortcuts: next.shortcuts });
    settingsStore.setState(toSettingsSlice(saved));
  });
  queue = run.catch(() => undefined);
  return run;
}
